'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const leaders = [
{
  name: 'James Oliver',
  title: 'Chief Executive Officer',
  bio: 'With over 30 years in affordable housing development, James has led Brickwell Housing from a regional developer to a nationally recognized firm.',
  image: "/assets/images/Executive1-1776911904399.png",
  alt: 'James Oliver, CEO of Brickwell Housing, professional headshot in business attire'
},
{
  name: 'Brenda Carson',
  title: 'Chief Operating Officer',
  bio: 'Brenda oversees day-to-day operations and ensures every Brickwell community meets the highest standards of quality and resident satisfaction.',
  image: "/assets/images/brenda_carson_executive.png",
  alt: 'Brenda Carson, COO of Brickwell Housing, professional headshot smiling confidently'
},
{
  name: 'Mark Logan',
  title: 'Chief Development Officer',
  bio: 'Mark leads Brickwell\'s development pipeline, identifying opportunities and guiding projects from concept through ribbon-cutting.',
  image: "/assets/images/Mark_Logan-1776928151681.png",
  alt: 'Mark Logan, Chief Development Officer of Brickwell Housing, professional headshot'
},
{
  name: 'Diane Torres',
  title: 'VP of Community Impact',
  bio: 'Diane champions resident services and social programs that transform Brickwell properties into thriving, connected communities.',
  image: "/assets/images/Diane_Torres-1776928453105.png",
  alt: 'Diane Torres, VP of Community Impact at Brickwell Housing, warm professional headshot'
}];


const values = [
{
  icon:
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#003c82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
      </svg>,

  title: 'Community First',
  desc: 'Every decision we make starts with the people who will call our properties home. We build neighborhoods, not just buildings.'
},
{
  icon:
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#003c82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><path d="M12 8v4l3 3" />
      </svg>,

  title: 'Long-Term Thinking',
  desc: 'We invest in communities for decades, not quarters. Our properties are built to last and our relationships are built to endure.'
},
{
  icon:
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#003c82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
      </svg>,

  title: 'Inclusive Access',
  desc: 'Quality housing is a right, not a privilege. We work tirelessly to make attainable, dignified homes available to everyone.'
},
{
  icon:
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#003c82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>,

  title: 'Integrity in Action',
  desc: 'We hold ourselves to the highest standards of transparency, accountability, and ethical practice in everything we do.'
}];


const milestones = [
{ year: '1973', label: 'Founded in Brooklyn with a single affordable housing development.' },
{ year: '1989', label: 'Expanded to 5 states, completing our 50th community.' },
{ year: '2001', label: 'Launched the Brickwell Resident Services program.' },
{ year: '2010', label: 'Surpassed 10,000 homes developed across the nation.' },
{ year: '2018', label: 'Introduced green building standards across all new developments.' },
{ year: '2024', label: 'Celebrating 50+ years and 20,000+ homes built.' }];


export default function AboutPage() {
  return (
    <main style={{ fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Hero */}
      <section
        style={{
          position: 'relative',
          minHeight: '480px',
          display: 'flex',
          alignItems: 'flex-end',
          overflow: 'hidden',
          paddingTop: '80px'
        }}>

        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: 'url(https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1600&h=700&fit=crop)',
            backgroundSize: 'cover',
            backgroundPosition: 'center 40%'
          }} />

        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(45deg, rgba(0,60,130,0.82) 0%, rgba(0,60,130,0.4) 60%, rgba(0,0,0,0.1) 100%)'
          }} />

        {/* Cyan triangle decoration */}
        <div
          style={{
            position: 'absolute',
            bottom: '-2px',
            right: 0,
            width: '40%',
            height: '100px',
            backgroundColor: '#6dcff6',
            clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
          }} />

        <div style={{ position: 'relative', maxWidth: '1280px', margin: '0 auto', padding: '0 24px 64px', width: '100%' }}>
          <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '12px' }}>
            Who We Are
          </p>
          <h1 style={{ fontSize: '52px', fontWeight: '400', color: '#ffffff', lineHeight: 1.1, margin: 0, maxWidth: '600px' }}>
            Building <em style={{ fontStyle: 'italic', color: '#6dcff6' }}>communities</em> that last a lifetime.
          </h1>
        </div>
      </section>

      {/* Our Story */}
      <section style={{ padding: '100px 0', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
            <div>
              <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '16px' }}>
                Our Story
              </p>
              <h2 style={{ fontSize: '40px', fontWeight: '400', color: '#003c82', lineHeight: 1.15, marginBottom: '28px' }}>
                Five decades of housing families across America.
              </h2>
              <p style={{ fontSize: '16px', lineHeight: 1.8, color: '#555', marginBottom: '20px' }}>Brickwell Housing was founded in 1973 with a straightforward belief: every family deserves a safe, quality home in a community where they can thrive. What began as a single development in Brooklyn, NY has grown into one of the country's most respected affordable and mixed-income housing firms.

              </p>
              <p style={{ fontSize: '16px', lineHeight: 1.8, color: '#555', marginBottom: '32px' }}>
                Over 50 years, we've developed more than 20,000 homes across 18 states — from urban high-rises to suburban townhomes to senior living communities. Through every project, our commitment to residents, partners, and the neighborhoods we serve has never wavered.
              </p>
              <div style={{ display: 'flex', gap: '40px' }}>
                {[
                { stat: '20,000+', label: 'Homes Developed' },
                { stat: '18', label: 'States' },
                { stat: '50+', label: 'Years of Service' }].
                map((item) =>
                <div key={item.label}>
                    <div style={{ fontSize: '36px', fontWeight: '700', color: '#003c82', lineHeight: 1 }}>{item.stat}</div>
                    <div style={{ fontSize: '13px', color: '#888', marginTop: '6px', letterSpacing: '0.05em' }}>{item.label}</div>
                  </div>
                )}
              </div>
            </div>
            <div style={{ position: 'relative' }}>
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_19fd7ff48-1767278159508.png"
                alt="Brickwell Housing team members reviewing architectural plans for a new affordable housing community"
                style={{ width: '100%', height: '500px', objectFit: 'cover', display: 'block' }} />

              <div style={{
                position: 'absolute',
                bottom: '-24px',
                left: '-24px',
                width: '180px',
                height: '180px',
                backgroundColor: '#6dcff6',
                zIndex: -1
              }} />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section style={{ padding: '100px 0', backgroundColor: '#003c82' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px' }}>
            <div>
              <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '16px' }}>
                Our Mission
              </p>
              <h2 style={{ fontSize: '36px', fontWeight: '400', color: '#ffffff', lineHeight: 1.2, marginBottom: '24px' }}>
                To develop, manage, and invest in housing that strengthens communities.
              </h2>
              <p style={{ fontSize: '16px', lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
                We believe that housing is the foundation of a stable life. Our mission is to create homes that are not only affordable and well-built, but that serve as anchors for the communities around them — places where residents can put down roots and build futures.
              </p>
            </div>
            <div>
              <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '16px' }}>
                Our Vision
              </p>
              <h2 style={{ fontSize: '36px', fontWeight: '400', color: '#ffffff', lineHeight: 1.2, marginBottom: '24px' }}>
                A nation where every person has access to a home they're proud of.
              </h2>
              <p style={{ fontSize: '16px', lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
                We envision a future where the zip code you're born into doesn't determine the quality of your housing. Through innovation, partnership, and persistence, Brickwell is working to close the housing gap — one community at a time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section style={{ padding: '100px 0', backgroundColor: '#f8f9fa' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '12px' }}>
              What Guides Us
            </p>
            <h2 style={{ fontSize: '40px', fontWeight: '400', color: '#003c82', margin: 0 }}>Our Core Values</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '2px', backgroundColor: '#e0e0e0' }}>
            {values.map((v) =>
            <div
              key={v.title}
              style={{
                backgroundColor: '#ffffff',
                padding: '48px 40px',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => {(e.currentTarget as HTMLDivElement).style.backgroundColor = '#f0f7ff';}}
              onMouseLeave={(e) => {(e.currentTarget as HTMLDivElement).style.backgroundColor = '#ffffff';}}>

                <div style={{ marginBottom: '20px' }}>{v.icon}</div>
                <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#003c82', marginBottom: '12px' }}>{v.title}</h3>
                <p style={{ fontSize: '15px', lineHeight: 1.75, color: '#666', margin: 0 }}>{v.desc}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* History Timeline */}
      <section style={{ padding: '100px 0', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ marginBottom: '64px' }}>
            <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '12px' }}>
              Our Journey
            </p>
            <h2 style={{ fontSize: '40px', fontWeight: '400', color: '#003c82', margin: 0 }}>50 Years of Impact</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0' }}>
            {milestones.map((m, i) =>
            <div
              key={m.year}
              style={{
                padding: '40px 36px',
                borderLeft: i % 3 !== 0 ? '1px solid #e0e0e0' : 'none',
                borderBottom: i < 3 ? '1px solid #e0e0e0' : 'none'
              }}>

                <div style={{
                fontSize: '48px',
                fontWeight: '700',
                color: '#6dcff6',
                lineHeight: 1,
                marginBottom: '16px',
                letterSpacing: '-0.02em'
              }}>{m.year}</div>
                <p style={{ fontSize: '15px', lineHeight: 1.7, color: '#555', margin: 0 }}>{m.label}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section style={{ padding: '100px 0', backgroundColor: '#f8f9fa' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <p style={{ color: '#6dcff6', fontSize: '13px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '12px' }}>
              Our People
            </p>
            <h2 style={{ fontSize: '40px', fontWeight: '400', color: '#003c82', margin: 0 }}>Executive Leadership</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }}>
            {leaders.map((leader) =>
            <div key={leader.name} style={{ textAlign: 'center' }}>
                <div style={{ position: 'relative', marginBottom: '20px', display: 'inline-block' }}>
                  <img
                  src={leader.image}
                  alt={leader.alt}
                  style={{
                    width: '180px',
                    height: '180px',
                    objectFit: 'cover',
                    borderRadius: '50%',
                    display: 'block',
                    border: '4px solid #ffffff',
                    boxShadow: '0 4px 20px rgba(0,60,130,0.15)'
                  }} />

                </div>
                <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#003c82', marginBottom: '4px' }}>{leader.name}</h3>
                <p style={{ fontSize: '13px', color: '#6dcff6', fontWeight: '600', letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '12px' }}>{leader.title}</p>
                <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#666', margin: 0 }}>{leader.bio}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '80px 0', backgroundColor: '#003c82' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '36px', fontWeight: '400', color: '#ffffff', marginBottom: '16px' }}>
            Ready to build something together?
          </h2>
          <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.75)', marginBottom: '36px' }}>
            Whether you're a prospective resident, investor, or community partner — we'd love to hear from you.
          </p>
          <a
            href="/portfolio"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#6dcff6',
              color: '#003c82',
              padding: '14px 32px',
              fontSize: '14px',
              fontWeight: '700',
              textDecoration: 'none',
              borderRadius: '2px',
              letterSpacing: '0.02em',
              marginRight: '16px'
            }}>

            View Our Portfolio
          </a>
          <a
            href="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: 'transparent',
              color: '#ffffff',
              padding: '14px 32px',
              fontSize: '14px',
              fontWeight: '600',
              textDecoration: 'none',
              borderRadius: '2px',
              border: '1px solid rgba(255,255,255,0.4)',
              letterSpacing: '0.02em'
            }}>

            Contact Us
          </a>
        </div>
      </section>

      <Footer />
    </main>);

}